import React, { memo as Memo, useMemo, useCallback, useRef, useEffect } from 'react'
import { useRouter } from 'next/router'

//* HOC's
import { withDataContext, withUIContext } from 'context'

//* Helpers
import { routerToPathAndQuery } from 'helpers'

//* Components
import { Text, GalleryItem, Container, Button, Page } from 'components/common'

//* Styles
import GalleryStyle from 'styles/pages/GalleryStyle'

const Gallery = Memo(({ winWidth, pageParams, prevPageParams, pages, gallery, selectedLang, winHeight, loading }) => {
    const router = useRouter()
    const galRef = useRef()

    const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])

    const galleriesData = useMemo(() => {
        return gallery?.[pageParams?.queryName]?.[selectedLang]
    }, [gallery, pageParams?.queryName, selectedLang])

    const storeGallery = useMemo(() => {
        if (galleriesData) {
            let arrOdd = []
            let arrEven = []

            for (let i = 0; i < galleriesData.galleries.length; i++) {
                if (i % 2 === 0) {
                    arrOdd.push(
                        <GalleryItem
                            key={i}
                            type={galleriesData.galleries[i].type}
                            src={galleriesData.galleries[i].featured_image}
                            title={galleriesData.galleries[i].title}
                            year={galleriesData.galleries[i].year}
                            category={galleriesData.galleries[i].category}
                            moreInfo={galleriesData.galleries[i].description}
                        />
                    )
                } else {
                    arrEven.push(
                        <GalleryItem
                            key={i}
                            type={galleriesData.galleries[i].type}
                            src={galleriesData.galleries[i].featured_image}
                            title={galleriesData.galleries[i].title}
                            year={galleriesData.galleries[i].year}
                            category={galleriesData.galleries[i].category}
                            moreInfo={galleriesData.galleries[i].description}
                        />
                    )
                }
            }
            return (
                <div className='content FlexBox'>
                    <div className='col col-1 FlexBoxColumn'>{arrOdd}</div>
                    <div className='col col-2 FlexBoxColumn'>{arrEven}</div>
                </div>
            )
        }

        return
    }, [galleriesData])

    const storeCats = useMemo(() => {
        return pageData?.categories.map((i, k) => {
            return (
                <Button
                    key={k}
                    onClick={() => onCategoryChange(pageParams.postType.queryParamKeys[0], i.id)}
                    className={`filter-btn galCat ${router.query.catId == i.id ? 'active' : ''}`}
                    text={i.name}
                />
            )
        })
    }, [pageData, router.query])

    //! Filter Change
    const onCategoryChange = useCallback(
        (cat, catId) => {
            const { pathname, query } = routerToPathAndQuery(router, cat, catId, false)
            pageParams.postType.queryParamKeys[1] !== cat && delete query[pageParams.postType.queryParamKeys[1]]
            router.push({ pathname, query }, undefined, { scroll: false })
        },
        [router.query]
    )

    return (
        <Page>
            <GalleryStyle ref={galRef}>
                <Container>
                    <Text tag={winWidth < 768 ? 'h5' : 'h3'} className={'gallery-title GHEAMariamBold uppercase'} text={'Gallery'} />
                    <div className='filter-btns FlexBox'>
                        <Button
                            className={`filter-btn galCat ${!router.query.catId ? 'active' : ''}`}
                            text={'All'}
                            onClick={() => {
                                router.replace(router.pathname, undefined, { shallow: false })
                            }}
                        />
                        {storeCats}
                    </div>
                    {storeGallery}
                </Container>
            </GalleryStyle>
        </Page>
    )
})

export default withDataContext(withUIContext(Gallery,
    ['winHeight', 'winWidth']),
    ['pages', 'gallery', 'loading'])

// export const getServerSideProps = async ({ query }) => {
// 	return { props: {} }
// }